import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SchoolIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M18 14.0185L20 13.1254V17.5444C20 18.7266 19.3027 19.8018 18.2231 20.2837L12 23.0625L5.77686 20.2837C4.69727 19.8018 4 18.7266 4 17.5444V13.1254L6 14.0185V17.5444C6 17.9385 6.23242 18.2969 6.59229 18.4575L12 20.8721L17.4077 18.4575C17.7676 18.2969 18 17.9385 18 17.5444V14.0185ZM24 8.02392V15H22V10.5894L12 15.0552L0 9.69629V8.02295L12.0112 1.87646L24 8.02392ZM21.1177 8.79346L12.0103 4.12354L2.88379 8.79395L12 12.8648L21.1177 8.79346V8.79346Z",
    fill: "currentColor"
  }));
}